import ProfitLossHTMLPreviewBaseSection from './ProfitLossHTMLPreviewBaseSection'

export default function ProfitLossHTMLPreviewGeneralCostsSection () {}

ProfitLossHTMLPreviewGeneralCostsSection.prototype = new ProfitLossHTMLPreviewBaseSection();

ProfitLossHTMLPreviewGeneralCostsSection.prototype.init = function( showLeaveTimeCosts, showOvertimeAddition, columnsStrategy )
{
    ProfitLossHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);
    this.showLeaveTimeCosts = showLeaveTimeCosts;
    this.showOvertimeAddition = showOvertimeAddition;
    return this;
};

ProfitLossHTMLPreviewGeneralCostsSection.prototype.addRows = function( tBody )
{
    var headerRow = this.createRow("generalCosts");
    this.addCell( headerRow, this.message( "report.general_costs" ), "", this.columnsStrategy.getDataColumnsCount() + 1 );
    this.addRow( tBody, headerRow );

    if( this.showLeaveTimeCosts )
    {
        this.addRowWithMainCell( tBody, this.message( "report.profit_loss.total_leave" ), "totalLeaveTimeCell", "totalLeaveTime" );
        this.addRowWithMainCell( tBody, this.message( "leave_type.leave_type" ), "leaveType" );
    }

    if( this.showOvertimeAddition )
        this.addRowWithMainCell( tBody, this.message( "report.profit_loss.overtime_bonus" ), "overtimeAdditionCell", "overtimeAddition" );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewGeneralCostsSection.js